<modal-component [fullWidth]="true">
	
	<!-- LEFT-->
	<ng-container left>
		<div class="_header">
			<p *ngIf="controller.action === controller.Action.CREATE" class="_title" [translate]="'WAIT_LIST.TITLE_CREATE'"></p>
			<p *ngIf="controller.action === controller.Action.UPDATE" class="_title" [translate]="'WAIT_LIST.TITLE_UPDATE'"></p>
		</div>

		<!-- info or context -->
		<div *ngIf="controller.action === controller.Action.CREATE" class="_info">
			<info-line icon="./assets/icons/info-outline.svg" align="top">
				<p>
					{{'WAIT_LIST.INFO' | translate}}
				</p>
			</info-line>			
		</div>

		<!-- info or context -->
		<div *ngIf="controller.action === controller.Action.UPDATE" class="_info">
			<info-line icon="./assets/icons/calendar-outline.svg" align="top">
				<p>
					<b>{{'WAIT_LIST.CREATED_AT' | translate }} </b><span>{{controller.waitListItem.createdAt | date}}</span>
				</p>
			</info-line>
			<info-line icon="./assets/icons/user-outline.svg" align="top">
				<p>
					<b>{{'WAIT_LIST.CREATED_BY' | translate }} </b><span>{{controller.waitListItem.CreatedBy.email}}</span>
				</p>
			</info-line>			
		</div>

		<div *ngIf="controller.action === controller.Action.UPDATE && controller.waitListItem.Event" class="_info">
			<info-line icon="./assets/icons/calendar-outline.svg">
				<p>{{controller.waitListItem.Event?.name}} ({{controller.waitListItem.Event?.EventType?.name}})</p>
			</info-line>				

			<info-line icon="./assets/icons/attendance-type-outline.svg" align="top">
				<p><b [translate]="'EVENT.ATTENDANCE_TYPE_TITLE'"></b></p>
				<ng-container [ngSwitch]="controller.waitListItem.Event?.attendanceType">
					<p *ngSwitchCase="controller.EventAttendanceType.Reservation">{{'EVENT_ATTENDANCE_TYPE.RESERVATION' | translate}}</p>
					<p *ngSwitchCase="controller.EventAttendanceType.Registration">{{'EVENT_ATTENDANCE_TYPE.REGISTRATION' | translate}}</p>
					<p *ngSwitchCase="controller.EventAttendanceType.WalkIn">{{'EVENT_ATTENDANCE_TYPE.WALKIN' | translate}}</p>
					<p *ngSwitchCase="controller.EventAttendanceType.Lessons">{{'EVENT_ATTENDANCE_TYPE.LESSONS' | translate}}</p>
				</ng-container>
			</info-line>

			<ng-container *ngIf="controller.waitListItem.Event?.locationType === controller.EventLocationType.OnLocation">
				<info-line icon="./assets/icons/location-outline.svg" align="top">
					<p><b>{{controller.waitListItem.Event?.Location?.place}}</b></p>
					<p [navigate]="[controller.InternalNavigationType.address, controller.waitListItem.Event?.Location?.Address]">{{controller.waitListItem.Event?.Location?.Address | address}}</p>
				</info-line>
			</ng-container>
				
			<ng-container *ngIf="controller.waitListItem.Event?.locationType === controller.EventLocationType.Online">
				<info-line icon="./assets/icons/online-event-outline.svg" align="top">
					<p><b [translate]="'EVENT.IS_ONLINE_EVENT'"></b></p>
					<p class="_url" [navigate]="[controller.InternalNavigationType.url, controller.waitListItem.Event?.url]">{{controller.waitListItem.Event?.url}}</p>
				</info-line>
			</ng-container>

			<info-line icon="./assets/icons/loan-outline.svg" align="top" *ngIf="controller.waitListItem.Event?.isLoanLocation">
				<p [translate]="'EVENT.IS_LOAN_LOCATION'"></p>
			</info-line>

			<info-line icon="./assets/icons/info-outline.svg" *ngIf="controller.waitListItem.Event?.description">
				<p><b>{{'EVENT.DESCRIPTION' | translate}}</b> {{controller.waitListItem.Event.description}}</p>
			</info-line>	

			<info-line icon="./assets/icons/agency-outline.svg" align="top">
				<p><b [translate]="'EVENT.DIGIBANK_AGENCY'"></b> {{controller.waitListItem.Event?.DigibankAgency?.name}}</p>
			</info-line>

			<info-line icon="./assets/icons/employees-outline.svg" align="top" *ngIf="controller.waitListItem.Event?.attendanceType === controller.EventAttendanceType.Registration">
				<p><b [translate]="'EVENT.MAX_REGISTRATIONS'"></b> 
					<span *ngIf="controller.waitListItem.Event?.maxRegistrations"> {{controller.waitListItem.Event?.maxRegistrations}}</span>
					<span *ngIf="!controller.waitListItem.Event?.maxRegistrations" [translate]="'EVENT.NO_MAX_REGISTRATIONS'"></span>
				</p>	
			</info-line>


			<info-line icon="./assets/icons/created-by-outline.svg" align="top" *ngIf="controller.waitListItem?.CreatedBy?.email">
				<p><b><span>{{'EVENT.CREATED_BY' | translate}}: </span></b><span [navigate]="[controller.InternalNavigationType.email, controller.waitListItem.CreatedBy?.email]">{{controller.waitListItem.CreatedBy?.email}}</span> 
					<span style="color: grey"> ({{controller.waitListItem.createdAt | date:"EEEE d MMM yyyy"}})</span>
				</p>
			</info-line>			
		</div>
	</ng-container>

	
	<!-- RIGHT -->
	<ng-container right>		
		<form [formGroup]="controller.waitListItemForm" *ngIf="controller.waitListItemForm">
			<!-- Client -->
			<form-client *ngIf="controller.action === controller.Action.CREATE" [formGroup]="controller.waitListItemForm.get('Client') | cast"></form-client>
			<ng-container *ngIf="controller.action === controller.Action.UPDATE && controller.waitListItem?.Client">
				<p  class="_title" [translate]="'CLIENT.TITLE'"></p>
				<client-details-component [client]="controller.waitListItem.Client"></client-details-component>
			</ng-container>

			<p  class="_title" [translate]="'WAIT_LIST.DESCRIPTION_TITLE'"></p>
			<form-select label="{{ 'WAIT_LIST.TYPE_LABEL' | translate }}" [formControl]="controller.waitListItemForm.get('type') | cast" [items]="controller.eventTypes" bindValue="name" bindLabel="name" [multiple]="false" position="top">
			</form-select>
			<form-textarea label="{{ 'WAIT_LIST.DESCRIPTION' | translate }}" [formControl]="controller.waitListItemForm.get('description') | cast"></form-textarea>
			
			<ng-container *ngIf="controller.action === controller.Action.UPDATE">
				<p  class="_title" [translate]="'WAIT_LIST.STATUS_LABEL'"></p>
				<form-select  label="{{ 'WAIT_LIST.STATUS_LABEL' | translate }}" [formControl]="controller.waitListItemForm.get('status') | cast" [items]="controller.waitListItemStatuses" bindValue="value" bindLabel="{{'label' | translate }}" [multiple]="false">
				</form-select>
			</ng-container>


		</form>
	</ng-container>

	<!-- BUTTONS -->
	<ng-container buttons>		
		<button (click)="controller.createOrUpdate()" class="_button _save-button" *ifUserHasPermissions="[controller.UserPermissions.WriteWaitList]">
			<span *ngIf="controller.action === controller.Action.CREATE"[translate]="'WAIT_LIST.CREATE'"></span>
			<span *ngIf="controller.action === controller.Action.UPDATE" [translate]="'WAIT_LIST.UPDATE'"></span>
		</button>
		<button class="_button _cancel-button" [translate]="'WAIT_LIST.CANCEL'" (click)="controller.close()"></button>
	</ng-container>	


</modal-component>